module.exports = __webpack_public_path__ + "img/mz_05.c40a0a39.png";